import React, { useState, useCallback, useMemo } from 'react'
import { nanoid } from 'nanoid'
import { Input, Button } from 'antd'
import {
  SvgCloseIcon,
  SvgMoreIcon,
} from '../../../../../../../components/svg/SvgComponents'

import styles from './EmailNotificationsGroupInput.module.css'
import { useContext } from 'react'
import {
  addEmailNotificationsGroup,
  updateEmailNotificationsGroup,
  deleteEmailNotificationsGroup,
} from '../../../../../../../services/api'

import DescriptionVisibleInput from '../DescriptionVisibleInput/DescriptionVisibleInput'
import { observer } from 'mobx-react-lite'
import AvatarRoles from '../../../../../../../components/AvatarRoles/AvatarRoles'

import { BuilderContext } from '../../../../store/store.Builder'

const EmailNotificationsGroupInput = observer(({ value = [], onChange }) => {
  const builderContext = useContext(BuilderContext)
  return (
    <div className={styles.container}>
      <div className={styles.switch}>
        <DescriptionVisibleInput value={value} onChange={onChange} />
      </div>
      <div></div>
      {value ? (
        <div className={styles.rules}>
          <AvatarRoles
            url_code={builderContext.url_code}
            title={'Notifications par email à chaque réponse'}
            userFullName={builderContext.userFullName}
            userUsername={builderContext.userUsername}
            dataAPI={builderContext.EmailNotificationsGroupDataAPI}
            onAddUser={addEmailNotificationsGroup}
            onEditUser={updateEmailNotificationsGroup}
            onDeleteUser={deleteEmailNotificationsGroup}
            isAdmin={builderContext.isAdmin}
          />
        </div>
      ) : null}
    </div>
  )
})

export default EmailNotificationsGroupInput
